import SubCollectionEntityService from '@/services/SubCollectionEntiyService'
import { WorkOrder, workOrderConverter } from '@/models/workOrder'
import BillService from './BillService'
import BudgetService from './BudgetService'

export default class WorkOrderService extends SubCollectionEntityService<WorkOrder> {
  constructor(parentDocument: string) {
    super({ parentDocument, subCollectionName: 'workOrders', converter: workOrderConverter })
  }

  async deleteWOWithBills (workOrder: WorkOrder): Promise<boolean> {
    const billService = new BillService()
    const allPromises = []
    // Get all bills related to the work order
    const bills = await billService.getByWorkOrderId(workOrder.workOrderId)

    // Delete all bills related to the work order
    bills.forEach((bill) => {
      allPromises.push(billService.forceDelete(bill.id))
    })

    // Delete the work order
    const budgetService = new BudgetService()
    allPromises.push(budgetService.deleteWorkOrder(workOrder.budgetId, workOrder.id))
    await Promise.all(allPromises)

    return true
  }

}
